module.exports = __webpack_public_path__ + "img/最牛弓射手.c3471aa0.png";